import homeView from './index'
import searchView from './search'

const routes = {
  path: 'tourcache',
  name: 'Private/TourCache',
  component: homeView,
  redirect: { name: 'Private/TourCache/Search' },
  children: [
    {
      path: 'search',
      name: 'Private/TourCache/Search',
      component: searchView
    }
  ]
}

export default routes
